export { DeckGLHeatmap, default } from "./DeckGLHeatmap";
